module.exports = __webpack_public_path__ + "img/game_logo2.7ecd04f4.png";